import {
  SITES_LOCATION_MAP,
} from "./type";

const initalState = {
  sitesLocMapList: [],
};

const sitesLocMapReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITES_LOCATION_MAP:
      return {
        ...state,
        sitesLocMapList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default sitesLocMapReducer;
